(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-dual-zone"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const toneOpacity = (v, min, max, split) => {
      if (v < split) return { cool: 0.35 + 0.65 * (split - v) / Math.max(1, split - min), warm: 0 };
      if (v > split) return { cool: 0, warm: 0.35 + 0.65 * (v - split) / Math.max(1, max - split) };
      return { cool: 0, warm: 0 };
    };
    const init = (root) => {
      root.querySelectorAll('[data-as-dual]').forEach((demo) => {
        const photo = demo.querySelector('[data-dual-photo]');
        if (!photo || demo.dataset.photoReady) return;
        demo.dataset.photoReady = '1';
        const min = +demo.dataset.min, max = +demo.dataset.max, split = +demo.dataset.split;
        const update = (input) => {
          const o = toneOpacity(+input.value, min, max, split);
          photo.querySelectorAll('[data-photo-side="' + input.dataset.side + '"]').forEach((img) => {
            img.style.opacity = o[img.dataset.tone];
          });
        };
        demo.querySelectorAll('input[data-side]').forEach((input) => {
          update(input);
          input.addEventListener('input', () => update(input));
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
    else init(document);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
